import React, { FC, useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import {
    Paper,
    Typography,
    TableContainer,
    Table,
    TableHead,
    TableBody,
    TableCell,
    TableRow,
  } from "@mui/material";
import { makeStyles } from '@material-ui/core/styles';
// import { group } from "console";
// import { title } from "process";

const useStyles = makeStyles({
    chartContainer: {
        position: 'relative',
        marginTop: '60px',
        padding: '10px 20px 15px',
        overflow: 'hidden'
    },
    tableCellGroupStyle: {
        color: '#fff', 
    },
    tableCellPropertyStyle: {
        padding: '5px',
        border: 'solid 1px #d9d9d9',
    },
    buttonStyle: {
        width: 200,
        height: 50,
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 4,
    },
});

// interface TableCellProps {
//     group?: string;
//     span?: number;
//     data: { label: string; value: number; orverValue: number }[];
// };

const DiplomaSupplementTicket: FC = () => {
    const { t } = useTranslation();
    const classes = useStyles();
    const [ticketData, setTicketData] = useState<any[]>([]);

    const seList = {
        header: t("credit.chart_title_1"),
        items: [
            {index: 1, label: t("common.ps8_1"), subItems: [
                {index: 1, label: t("common.perspective_1")},
                {index: 2, label: t("common.perspective_2")},
                {index: 3, label: t("common.perspective_3")},
            ]},
            {index: 2, label: t("common.ps8_2"), subItems: [
                {index: 4, label: t("common.perspective_4")},
                {index: 5, label: t("common.perspective_5")},
                {index: 6, label: t("common.perspective_6")},
            ]},
            {index: 3, label: t("common.ps8_3"), subItems: [
                {index: 7, label: t("common.perspective_7")},
                {index: 8, label: t("common.perspective_8")},
                {index: 9, label: t("common.perspective_9")},
                {index: 10, label: t("common.perspective_10")},
            ]},
            {index: 4, label: t("common.ps8_4"), subItems: [
                {index: 11, label: t("common.perspective_11")},
                {index: 12, label: t("common.perspective_12")},
            ]},
        ]
    };

    const tsList = {
      header: t("credit.chart_title_2"),
      items: [
            {index: 5, label: t("common.ps8_5"), subItems: [
                {index: 13, label: t("common.perspective_13")},
                {index: 14, label: t("common.perspective_14")},
                {index: 15, label: t("common.perspective_15")},
                {index: 16, label: t("common.perspective_16")},
            ]},
            {index: 6, label: t("common.ps8_6"), subItems: [
                {index: 17, label: t("common.perspective_17")},
                {index: 18, label: t("common.perspective_18")},
                {index: 19, label: t("common.perspective_19")},
            ]},
            {index: 7, label: t("common.ps8_7"), subItems: [
                {index: 20, label: t("common.perspective_20")},
                {index: 21, label: t("common.perspective_21")},
                {index: 22, label: t("common.perspective_22")},
                {index: 23, label: t("common.perspective_23")},
                {index: 24, label: t("common.perspective_24")},
            ]},
            {index: 8, label: t("common.ps8_8"), subItems: [
                {index: 25, label: t("common.perspective_25")},
                {index: 26, label: t("common.perspective_26")},
            ]},
        ]
    };

    const createTable = (data: any) => {
        return (
            <>
              <TableContainer>
                  <Table aria-label="simple table" sx={{ border: 'solid 1px #d9d9d9' }}>
                    <TableHead key="table-head">
                      <TableRow key="table-head-row">
                        <TableCell sx={{ textAlign: 'center' }} colSpan={4}>{data.header}</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody key="table-body">
                      <TableRow>
                        <TableCell sx={{ textAlign: 'center' }} colSpan={2}>{t("ds.sampleContent4.credit_header1")}</TableCell>
                        <TableCell sx={{ textAlign: 'center' }} colSpan={2}>{t("ds.sampleContent4.credit_header2")}</TableCell>
                      </TableRow>
                      {data.items.map(( item: any, index: number ) => (
                        <React.Fragment key={`${item.label}-${index}`}>
                          <TableRow>
                              <TableCell rowSpan={item.subItems.length+1}>{item.index}</TableCell>
                              <TableCell rowSpan={item.subItems.length+1}>{item.label}</TableCell>
                          </TableRow>
                          {item.subItems.map((subitem: any, subindex: number) =>(
                            <TableRow key={`${subitem.label}-${subindex}`}>
                                <TableCell>{subitem.index}</TableCell>
                                <TableCell>{subitem.label}</TableCell>
                            </TableRow>
                          ))}
                        </React.Fragment>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
            </>
          );
    };

    const CreditTicket = () => {
        return (
        <>
            <div className="flex flex-row justify-center items-start w-full">
                {createTable(seList)}
                {createTable(tsList)}
            </div>
        </>
        );
    };

    const createData = (data: any) => {        
        const fixData = [
          { group: t("ds.sampleHeader1"),
            span: 1,
            data: [t("ds.sampleContent1")]
          },
          { group: t("ds.sampleHeader2"),
            span: 1,
            data: [t("ds.sampleContent2")]
          },
          { group: t("ds.sampleHeader3"),
            span: 1,
            data: [t("ds.sampleContent3")]
          },
          { group: t("ds.sampleHeader4"),
            span: 1,
            data: [t("ds.sampleContent4_1"), <CreditTicket />, t("ds.sampleContent4_2")]
          },
          { group: t("ds.sampleHeader5"),
            span: 1,
            data: [t("ds.sampleContent5")]
          },
          { group: t("userAchievements.arch_1"),
            span: 5,
            data: [t("ds.sampleContentArch")]
          },
          { group: t("userAchievements.arch_2"),
            span: 0,
            data: []
          },
          { group: t("userAchievements.arch_3"),
            span: 0,
            data: []
          },
          { group: t("userAchievements.arch_8"),
            span: 0,
            data: []
          },
          { group: t("ds.selfReflection"),
            span: 0,
            data: []
          },
        ];
        setTicketData(fixData);
    };

    useEffect(() => {
        createData({});
    }, []);

    return (
    <>  
        <Paper className={classes.chartContainer}>
            <Typography>{t("ds.sampleForm")}</Typography>
            <TableContainer>
                <Table aria-label="simple table">
                  <TableBody key="table-body">
                    {ticketData && ticketData.map((ticketItem: any, ticketIndex: number) =>(
                      <React.Fragment key={`${ticketItem.group}-${ticketIndex}`}>
                        <TableRow>
                            <TableCell className={`${classes.tableCellPropertyStyle} w-1/5`}>
                                <div dangerouslySetInnerHTML={{ __html: ticketItem.group }} />
                            </TableCell>
                            {ticketItem.span > 0 && (
                            <TableCell className={classes.tableCellPropertyStyle} rowSpan={ticketItem.span}>
                                {ticketItem.data.map((item: any, index: number) => (
                                    <div key={index}>
                                        {typeof item === 'string' ? (
                                        <div dangerouslySetInnerHTML={{ __html: item }} />
                                        ) : (
                                            item
                                        )}
                                    </div>
                                ))}
                            </TableCell>
                            )}
                        </TableRow>
                        {[1, 2, 4].includes(ticketIndex) && (<tr><td style={{ height:"10px" }}></td></tr>)}
                      </React.Fragment>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
        </Paper>
    </>
    );
};

export default DiplomaSupplementTicket;